import React, { useMemo } from "react";
import {
  BarChart,
  Bar,
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  Legend,
} from "recharts";
const numberRegex = /^-?\d+(\.\d+)?$/;

export default function TableChart({ table, chartType = "bar" }) {
  const columns = table?.columns || [];
  const rows = table?.rows || [];

  const numericColumns = useMemo(() => {
    if (!columns.length || !rows.length) return [];
    return columns.filter((col, index) =>
      rows.some((row) => !isNaN(parseFloat(row[index])))
    );
  }, [columns, rows]);

  const stringColumns = useMemo(() => {
    if (!columns.length || !rows.length) return [];
    return columns.filter((col, index) =>
      rows.some((row) => isNaN(parseFloat(row[index])))
    );
  }, [columns, rows]);

  const xAxisCol = stringColumns[0] || "Row";

  const chartData = useMemo(() => {
    if (!columns.length || !rows.length) return [];

    return rows.map((row, index) => {
      let obj = {};
      obj[xAxisCol] = stringColumns.length
        ? row[columns.indexOf(xAxisCol)]
        : `Row ${index + 1}`;

      numericColumns.forEach((col) => {
        const value = row[columns.indexOf(col)];
        obj[col] = parseFloat(value) || 0;
      });

      return obj;
    });
  }, [columns, rows, numericColumns, stringColumns, xAxisCol]);

  if (!columns.length || !rows.length) {
    return <div style={{ padding: "20px" }}>No chart data available</div>;
  }

  const COLORS = [
    "#6366F1",
    "#10B981",
    "#F59E0B",
    "#EF4444",
    "#06B6D4",
    "#8B5CF6",
  ];

  const formatYAxis = (value) => {
    console.log("val", value)
    if (typeof value === "number" || (typeof value == "string" && numberRegex.test(value?.trim()))) {
      if (value >= 1_000_000_000) return `${(value / 1_000_000_000).toFixed(1)}B`;
      if (value >= 1_000_000) return `${(value / 1_000_000).toFixed(1)}M`;
      if (value >= 1_000) return `${(value / 1_000).toFixed(1)}K`;
    }
    return value;
  };


  return (
    <div className="chart-wrapper" style={{ width: "100%", height: "80%" }}>
      <ResponsiveContainer>
        {chartType === "line" ? (
          <LineChart data={chartData}>
            <XAxis dataKey={xAxisCol}
            stroke="#ddd"
              tick={{ fill: "#666", fontSize: 12 }}
            />
            <YAxis tickFormatter={formatYAxis}
            stroke="#ddd"
              tick={{ fill: "#666", fontSize: 12 }}
            />
            <Tooltip />
            <Legend />

            {numericColumns.map((col, index) => (
              <Line
                key={col}
                dataKey={col}
                type="monotone"
                stroke={COLORS[index % COLORS.length]}
                strokeWidth={2}
                dot={false}
                activeDot={{ r: 4 }}
              />
            ))}
          </LineChart>
        ) : (
          <BarChart data={chartData}>
            <XAxis dataKey={xAxisCol}
              stroke="#ddd"
              tick={{ fill: "#666", fontSize: 12 }}
            />
            <YAxis tickFormatter={formatYAxis}
              stroke="#ddd"
              tick={{ fill: "#666", fontSize: 12 }}
            />
            <Tooltip />
            <Legend />

            {numericColumns.map((col, index) => (
              <Bar
                key={col}
                dataKey={col}
                fill={COLORS[index % COLORS.length]}
                maxBarSize={40}
                radius={[4, 4, 0, 0]}
              />
            ))}
          </BarChart>
        )}
      </ResponsiveContainer>
    </div>
  );
}
